// extracted by mini-css-extract-plugin
module.exports = {"box":"box-module--box--1JVq8"};